import { render, staticRenderFns } from "./FormRegister.vue?vue&type=template&id=8d8a0d1e"
import script from "./FormRegister.vue?vue&type=script&lang=js"
export * from "./FormRegister.vue?vue&type=script&lang=js"
import style0 from "./FormRegister.vue?vue&type=style&index=0&id=8d8a0d1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports